import { DOM } from './index'

let CONTRAST_DOM = {
    updateContrastList() {
        let listBox = document.getElementsByClassName('contrast-list')[0],
            listDom = document.getElementById('ContrastVirtualList'),
            topBarDom = document.getElementsByClassName('contrast-list-topbar')[0];
        if(listBox && topBarDom) {
            listBox.style = "padding-top:"+topBarDom.clientHeight+'px';
        }
        if(listDom && topBarDom) {
            listDom.style.height = (innerHeight - topBarDom.clientHeight) + 'px';
        }
    },
    updateContrastPage() {
        let listDom = document.getElementsByClassName('contrast-page-list')[0],
            listBox = document.getElementsByClassName('contrast-page-list-box')[0],
            titleBarDom = document.getElementsByClassName('contrast-page-title-bar')[0],
            bottomBarDom = document.getElementsByClassName('contrast-bottom-bar')[0];
        if(listBox && titleBarDom) {
            listBox.style = "padding-top:"+titleBarDom.clientHeight+'px';
        }
        if(listDom && titleBarDom && bottomBarDom) {
            listDom.style.height = (innerHeight - titleBarDom.clientHeight - bottomBarDom.clientHeight) + 'px';
        }
    }
}

export {
    CONTRAST_DOM
}